import { useEffect } from "react";
import { EMAIL } from "../constants/site";
import "./PrivacyPolicy.css";

export const PolicyPage = ({ policy }) => {
    useEffect(() => {
        document.title = policy.titleTag;
        window.scrollTo(0, 0);
        return () => {
            document.title = "GrowCo";
        };
    }, [policy]);

    return (
        <main className="policy" data-testid="policy-page">
            <div className="policy-inner">
                <header className="policy-topbar">
                    <a href="/" className="policy-logo" data-testid="policy-logo-link">
                        <img
                            src="/brand/growco-wordmark.png"
                            alt="GrowCo"
                            className="navbar-logo-img"
                        />
                    </a>
                    <a href="/" className="policy-back" data-testid="policy-back-link">
                        Back to site
                    </a>
                </header>

                <p className="eyebrow" data-testid="policy-eyebrow">
                    Legal
                </p>
                <h1 className="policy-heading" data-testid="policy-heading">
                    {policy.headingLead}{" "}
                    <span className="serif">{policy.headingAccent}</span>.
                </h1>
                <p className="policy-meta" data-testid="policy-meta">
                    {policy.meta}
                </p>

                {policy.intro && (
                    <p className="policy-intro" data-testid="policy-intro">
                        {policy.intro}
                    </p>
                )}

                {policy.sections.map((section, i) => (
                    <section
                        className="policy-section"
                        key={section.title}
                        data-testid={`policy-section-${i + 1}`}
                    >
                        <h2 className="policy-section-title">{section.title}</h2>
                        {section.intro && (
                            <p className="policy-text">
                                {section.intro}
                                {section.email && (
                                    <a
                                        className="policy-mail"
                                        href={`mailto:${EMAIL}`}
                                        data-testid={`policy-mail-${i + 1}`}
                                    >
                                        {EMAIL}
                                    </a>
                                )}
                            </p>
                        )}
                        {section.paragraphs &&
                            section.paragraphs.map((text, j) => (
                                <p className="policy-text" key={j}>
                                    {text}
                                </p>
                            ))}
                        {section.subs &&
                            section.subs.map((sub) => (
                                <div className="policy-sub" key={sub.title}>
                                    <h3 className="policy-sub-title">
                                        {sub.title}
                                    </h3>
                                    {sub.paragraphs.map((text, j) => (
                                        <p className="policy-text" key={j}>
                                            {text}
                                        </p>
                                    ))}
                                </div>
                            ))}
                        {section.bullets && (
                            <ul className="policy-list">
                                {section.bullets.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                        )}
                        {section.outro && (
                            <p className="policy-text">{section.outro}</p>
                        )}
                        {section.emails && (
                            <p className="policy-text policy-emails">
                                {section.emails.map((address) => (
                                    <a
                                        className="policy-mail"
                                        key={address}
                                        href={`mailto:${address}`}
                                        data-testid={`policy-mail-${address.split("@")[0]}`}
                                    >
                                        {address}
                                    </a>
                                ))}
                            </p>
                        )}
                    </section>
                ))}

                <p className="policy-copy" data-testid="policy-copyright">
                    © 2024 Tondku LLP. All rights reserved.
                </p>
            </div>
        </main>
    );
};
